import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";
import { ConditionValueType } from "../types/ConditionTypeList";

const fetchConditionValueTypes = (authHeader: string) => () =>
  axios.get<ConditionValueType[]>(`${env.verifyServiceUrl}common/condition_value_type_list/`, {
    headers: {
      Authorization: authHeader,
    },
  });
export const useConditionValueTypeList = () => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();
  return useQuery(["ConditionValueType"], fetchConditionValueTypes(authHeader), {
    retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
      if(err.request.status === 401) {
        navigate(ROUTE.LOGOUT);
      }
    }
  });
};
